import * as z from 'zod';
import { toilRequestFormSchema } from '../../hr-my-toil/schemas/toil-request-form-schema';

/** The TOIL request form plus the employee it is filed for (past days allowed). */
export const toilForEmployeeFormSchema = toilRequestFormSchema.extend({
  UserId: z.string().min(1, { message: 'TOIL_EMPLOYEE_REQUIRED' }),
});

export type ToilForEmployeeFormValues = z.infer<typeof toilForEmployeeFormSchema>;
